import Events from './events';

export default Events;
